import styled from 'styled-components'
import React from 'react'

const StyledHeader = styled.header`
  flex: 0 0 55px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: var(--dark);
  color: white;
`

export const Header = ({ children }: { children: JSX.Element }): JSX.Element => (
  <StyledHeader>
    {children}
  </StyledHeader>
)
